jQuery(document).ready(function($) {
	$('.hero-slider-container').flickity({
    cellSelector: '.hero-slide',
    cellAlign: 'left',
    draggable: true,
    pageDots: true,
    prevNextButtons: true,
		autoPlay: true,
		wrapAround: true,
    arrowShape: 'M41.7344 73.8402C42.3983 74.4405 42.7303 75.1909 42.7303 76.0914C42.7303 76.9919 42.3983 77.7423 41.7344 78.3427C41.1309 78.943 40.3916 79.2581 39.5165 79.2882C38.6413 79.3182 37.902 79.003 37.2985 78.3427L0.995833 41.8728C0.331941 41.2725 0 40.5371 0 39.6666C0 38.7961 0.331941 38.0307 0.995833 37.3703L37.2985 0.90049C37.902 0.300156 38.6413 0 39.5165 0C40.3916 0 41.1309 0.300156 41.7344 0.90049C42.3983 1.56085 42.7303 2.32627 42.7303 3.19674C42.7303 4.06722 42.3983 4.80261 41.7344 5.40294L11.9569 36.2394L95.6056 36.2394C96.5721 36.2394 97.3971 36.5811 98.0805 37.2646C98.7639 37.948 99.1056 38.7729 99.1056 39.7394C99.1056 40.7059 98.7639 41.5309 98.0805 42.2143C97.3971 42.8977 96.5721 43.2394 95.6056 43.2394L12.1845 43.2394L41.7344 73.8402L41.7344 73.8402Z',
	});
})
